<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Sue Frazer started experimenting with writing short stories in her childhood, finding opportunities in the hurly-burly of life to set down her thoughts and observations. She joined a creative writing group several years ago and since retirement has experienced some tough challenges which she feels have given her a new, more insightful view of the world. Sue’s writing encompasses a broad spectrum of fiction, from dark to light, horror to humour. And sometimes a mixture of more than one component.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?c4f7f02c